import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import saveProvidersMutation from './mutation.graphql.js'

export function useOnSubmit(props) {
  let connection_id = useDataValue({
    context: 'connection',
    viewPath: props.viewPath,
    path: 'id',
  })

  let submit = useDataSubmit({
    context: 'app',
    path: 'connections',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()

  let [, executeMutation] = useMutation(saveProvidersMutation)

  return async function onSubmit(provider_ids) {
    let objects = provider_ids.map(provider_id => ({
      connection_id,
      provider_id,
    }))

    let mutationResponse = await executeMutation({
      connection_id,
      objects,
    })

    if (mutationResponse.error) {
      return notify(
        notifyError('An error has occurred assigning the providers')
      )
    }

    notify(notifySuccess('Providers assigned correctly'))

    submit({ type: 'refetch' })

    if (typeof props.closePopover === 'function') props.closePopover()
  }
}

export function useOnFilter(props) {
  return function onFilter(value, items) {
    let valueRegex = new RegExp(value, 'i')
    return items.filter(item =>
      valueRegex.test(
        item.employment_contract.person.first_name +
          ' ' +
          item.employment_contract.person.last_name
      )
    )
  }
}
